import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_2 = { class: "flex-fill info-container" }
const _hoisted_3 = { class: "d-flex align-items-center w-100 first-line" }
const _hoisted_4 = {
  key: 0,
  class: "last-message-date-time info ml-1 flex-fill"
}
const _hoisted_5 = {
  key: 1,
  class: "close-wrapper text-right"
}
const _hoisted_6 = {
  key: 2,
  class: "close-wrapper text-right"
}
const _hoisted_7 = { key: 3 }
const _hoisted_8 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_9 = { key: 5 }
const _hoisted_10 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_11 = {
  key: 1,
  class: "options-with-icons-line"
}
const _hoisted_12 = { class: "info info-rows" }
const _hoisted_13 = {
  key: 0,
  class: "text-truncate last-message"
}
const _hoisted_14 = { class: "last-message-sender" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 2 }
const _hoisted_19 = ["href"]
const _hoisted_20 = { key: 3 }
const _hoisted_21 = {
  key: 4,
  class: "d-flex"
}
const _hoisted_22 = { class: "d-flex" }
const _hoisted_23 = { class: "statistic-number text-truncate" }
const _hoisted_24 = { class: "statistic-number text-truncate" }
const _hoisted_25 = { class: "statistic-number text-truncate" }
const _hoisted_26 = { class: "flex-fill text-truncate" }
const _hoisted_27 = { key: 5 }
const _hoisted_28 = { key: 6 }
const _hoisted_29 = {
  key: 7,
  style: {"white-space":"initial"},
  class: "mt-1"
}
const _hoisted_30 = { class: "d-flex align-items-center min-width-0" }
const _hoisted_31 = { class: "flex-fill text-truncate pl-2" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }

import {computed, ref, watch} from 'vue';
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import DateHelper from "~/ts/library/Date";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {__} from "~/ts/library/Translate";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import CoreUiChatClientAvatar from "~/core-ui/vue/chat/CoreUiChatClientAvatar.vue";
import OperatorApplicationSideMenuItem from "~/operatorApplication/vue/layout/OperatorApplicationSideMenuItem.vue";
import CoreUiHtmlify from "~/core-ui/vue/ui/CoreUiHtmlify.vue";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import Typing from "~/operatorApplication/ts/service/comet/listeners/Typing";
import OperatorTyping from "~/operatorApplication/ts/service/comet/listeners/OperatorTyping";
import BuddyListItemIcons from "~/operatorApplication/vue/dialogs/buddyList/item/BuddyListItemIcons.vue";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {OperatorApplicationDialogsStore} from "~/operatorApplication/ts/store/OperatorApplicationDialogsStore";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import StringHelper from "~/ts/library/StringHelper";
import Skeleton from "~/core-ui/vue/Skeleton.vue";
import Tags from "~/cabinet/vue/interface/data/Tags.vue";
import getCurrentDialogOfClient from "~/operatorApplication/ts/service/buddyList/getCurrentDialogOfClient";
import getCurrentVisitTime from "~/operatorApplication/ts/service/buddyList/getCurrentVisitTime";
import ClientIconsBeforeName from "~/operatorApplication/vue/dialogs/ClientIconsBeforeName.vue";
import {icon} from "~/ts/vuePlugins/IconPlugin";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {MyTooltipOptionInterface} from "~/core-ui/vue/ui/my-tooltip/MyTooltipOptionInterface";
import {useRawComponent} from "~/core-ui/ts/useRawComponent";
import BuddyListItemTextTooltip from "~/operatorApplication/vue/dialogs/buddyList/item/BuddyListItemTextTooltip.vue";
import BuddyListItemVisitsTooltip
    from "~/operatorApplication/vue/dialogs/buddyList/item/BuddyListItemVisitsTooltip.vue";
import BuddyListItemPageCountTooltip
    from "~/operatorApplication/vue/dialogs/buddyList/item/BuddyListItemPageCountTooltip.vue";
import CoreUiOperatorAvatar from "~/core-ui/vue/chat/CoreUiOperatorAvatar.vue";
import getOperatorDisplayName from "~/operatorApplication/ts/service/operators/getOperatorDisplayName";
import getLastClientDialogStatus from "~/operatorApplication/ts/data/getLastClientDialogStatus";
import getTimeStringByTimestamp from "~/operatorApplication/ts/service/buddyList/getTimeStringByTimestamp";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";


const __default__ = {
    name: "BuddyListItem"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    username: {},
    selected: { type: Boolean },
    groupSiteId: {},
    buddyList: {},
    showHidden: { type: Boolean },
    selectedUsernameExistInList: { type: Boolean, default: true }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

let props = __props

let emits = __emit;

const MAX_OPTION_ICONS = 4;

let typing = ref<{ label: string, text: string }>();

addDisposableEvent(
    OperatorApplicationEventManager.addEventListener(
        Typing.getEventNameByUsername(props.username),
        (text: string) => {
            typing.value = text ? {
                label: __("Печатает"),
                text
            } : null;
        }
    )
);
addDisposableEvent(
    OperatorApplicationEventManager.addEventListener(
        OperatorTyping.getEventNameByUsername(props.username),
        (payload: CometOperatorApplication.OperatorTypingCometMessageOpenApiModel) => {
            if (CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(userdata.value)) {
                if (payload.text) {
                    let operator = OperatorAccountStore.operatorsDictionary.value[payload.operator];
                    if (operator) {
                        typing.value = {
                            label: operator.fio,
                            text: `${__("Печатает")}...`
                        };
                    }
                } else {
                    typing.value = null;
                }
            }
        }
    )
);


let userdata = computed(() => {
    return ClientUserdataStore.getByUsername(props.username);
});

let optionsWithIcons = computed(() => OperatorApplicationBuddyList.getUserdataFieldOptionsWithIcons(userdata.value));


let isFree = computed(() => {
    if (userdata.value) {
        return ClientUserdataStore.isFreeByUserdata(userdata.value);
    }
    return false;
});

function emitClick() {
    if (userdata.value) {
        emits('click')
    }
}

let crossOperatorChat = computed(() => {
    if (userdata.value?.type.isCrossOperatorsChat) {
        return OperatorAccountStore.crossOperatorChat.value[props.username];
    }
    return null;
});

let forcedStatus = computed(() => {
    return crossOperatorChat.value ? crossOperatorChat.value.statusGetter() : null;
});

watch(forcedStatus, () => {
    userdata.value.status = forcedStatus.value;
});

function secondsFormat(seconds: number) {
    return DateHelper.secondsFormatToClosestFloor(seconds);
}

let isNewUnreadedDialog = computed(() => {
    return ClientUserdataStore.isClientHasNewDialog(props.username);
});

let currentVisitTime = computed(() => {
    return getCurrentVisitTime(userdata.value);
});

let city = computed(() => {
    if (userdata.value?.location) {
        let city = userdata.value.location.city;
        if (city) {
            return OperatorApplicationConfigInstance.isRussian ? city.ru : city.en;
        } else {
            let country = userdata.value.location.country;
            if (country) {
                return OperatorApplicationConfigInstance.isRussian ? country.ru : country.en;
            }
        }
    }
    return null;
});

let integrationPlatform = computed(() => {
    let integration = userdata.value?.integration;
    if (integration) {
        return OperatorAccountStore.integrationPlatformDictionary.value[integration.aggregationPlatformId ?? integration.platformId];
    } else {
        return null;
    }
});

let lastMessage = computed(() => {
    return userdata.value?.lastMessage;
});

let lastMessageTime = computed<string | number>(() => {
    if (lastMessage.value) {
        if (lastMessage.value.isSendByClient && configInstance.value.buddyListShowTimeFromLastQuestion) {
            let now = Math.ceil(Date.now() / 1000);
            let timestamp = lastMessage.value.dateTime;
            let delta = now - timestamp;
            if (delta < 60) {
                delta = DateHelper.nowEverySecondInSeconds - timestamp;
            } else {
                delta = DateHelper.nowInSeconds - timestamp;
            }
            return delta > 0 ? delta : 1;
        } else {
            return getTimeStringByTimestamp(lastMessage.value.dateTime);
        }
    }
    return null;
});

let unreadedStateList = computed(() => ClientUserdataStore.getUnreadedStateListByUserdata(userdata.value));

let isOutOfDialogLimit = computed(() => {
    let result = false;
    let userdataValue = userdata.value;
    if (getCurrentDialogOfClient(userdataValue)?.isOperatorInDialog) {
        if (OperatorAccountStore.outOfDialogsLimitSiteIds.value.length) {
            result = true;
        }
    }
    return result;
});

let lastMessageSender = computed(() => {
    if (lastMessage.value) {
        if (!lastMessage.value.isSendByClient || CoreUiChatHistoryHelper.isOneOfCrossOperatorsChatMessage(lastMessage.value)) {
            let login = lastMessage.value.operatorLogin;
            if (login == OperatorAccountStore.login.value) {
                return __("Вы");
            } else {
                let operator = OperatorAccountStore.operatorsDictionary.value[login];
                if (operator) {
                    return operator.fio;
                } else {
                    return login;
                }
            }
        }
    }
    return null;
});

let unreadedCountBadgeType = computed(() => {
    let result = "danger";
    if (userdata.value) {
        if (userdata.value.unreadedAdminMessageIds.length == userdata.value.unreadedMessageIds.length) {
            result = "success";
        }
    }
    return result;
});

let configInstance = computed(() => {
    return OperatorApplicationConfigInstance;
});

let referer = computed(() => {
    if (userdata.value) {
        return userdata.value.lastReferer ? userdata.value.lastReferer : userdata.value.referer;
    } else {
        return null;
    }
});

function getOperatorGroups(login: string) {
    let result: string[] = [];
    if (props.groupSiteId) {
        let site = OperatorAccountStore.sitesDictionary.value[props.groupSiteId];
        if (site) {
            result = site.groups
                .filter(group => group.operators.includes(login))
                .map(group => group.descr);
        }
    }
    return result.length ? result.join(", ") : undefined;
}

async function close() {
    if (props.buddyList.isCustomSearchList) {
        OperatorApplicationDialogsStore.setSelectedUsername({
            buddyListId: props.buddyList.id,
            username: null
        });
    } else {
        OperatorApplicationBuddyList.removeClientWithConfirmation(props.username);
    }
}

async function toggleHide() {
    userdata.value.isHiddenForOperator = !userdata.value.isHiddenForOperator;
    let value = userdata.value.isHiddenForOperator;
    let p: OperatorApplicationApi.OperatorBuddyListUpdateClientInfoOpenApiModel = {
        username: props.username,
        hiddenForMe: value
    };


    let result = await (new OperatorApiRequest({
        url: "/buddyList/updateClientInfo",
        p,
        silent: true
    })).send();
    if (result.showMessageOnError()) {
        userdata.value.isHiddenForOperator = !value;
    }
}

let canViewReferer = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canViewReferers, userdata.value.siteId);
});

let site = computed(() => {
    if (userdata.value?.siteId) {
        return OperatorAccountStore.sitesDictionary.value[userdata.value.siteId];
    } else {
        return null;
    }
});

let textTooltip = computed<MyTooltipOptionInterface>(() => {
    if (userdata.value?.lastMessage) {
        if (OperatorApplicationConfigInstance.buddyListShowLastMessageTooltip) {
            if (!props.selected) {
                return {
                    delay: 1000,
                    placement: "right-start",
                    component: useRawComponent(BuddyListItemTextTooltip),
                    props: {
                        userdata: userdata.value
                    }
                }
            }
        }
    }
    return null;
});

let pageCountTooltip = computed<MyTooltipOptionInterface>(() => {
    return {
        delay: 500,
        component: useRawComponent(BuddyListItemPageCountTooltip),
        props: {
            userdata: userdata.value
        }
    }
});

let visitsTooltip = computed<MyTooltipOptionInterface>(() => {
    return {
        delay: 500,
        component: useRawComponent(BuddyListItemVisitsTooltip),
        props: {
            userdata: userdata.value,
            currentVisitTime: currentVisitTime.value
        }
    }
});

let isShowStatus = computed(() => {
    return !OperatorAccountStore.crossOperatorChat.value[props.username]?.group;
});

let attachedOperators = computed(() => userdata.value?.attachedOperators
    .map(login => OperatorAccountStore.operatorsDictionary.value[login])
    .filter(operator => !!operator) ?? []
);

let dialogStatus = computed(() => getLastClientDialogStatus(userdata.value));

let isCloseAvailable = computed(() => {
    if (userdata.value.isPinned) {
        return false;
    }
    if (props.buddyList.isMainBuddyList) {
        if (dialogStatus.value?.isRemoveFromBuddyListAvailable === false) {
            if (userdata.value.lastDialog?.assigned.isAssignedToYou) {
                return false;
            }
        }
        return true;
    } else if (props.buddyList.isCustomSearchList) {
        return props.selected && !props.selectedUsernameExistInList;
    }
    return false;
});


return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_on_native = _resolveDirective("on-native")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(userdata) || !_unref(userdata).isHiddenForOperator || __props.showHidden)
      ? _withDirectives((_openBlock(), _createBlock(OperatorApplicationSideMenuItem, {
          key: 0,
          class: _normalizeClass({
                'buddy-list-item-inner': true,
                'unreaded': _unref(userdata) && _unref(userdata).unreadedMessageIds.length > 0,
                'offline': _unref(userdata) && !_unref(userdata).status && !_unref(userdata).integration,
                'main-list': __props.buddyList.isMainBuddyList,
                'custom-list': __props.buddyList.isCustomSearchList,
                'is-out-of-dialogs-limit': _unref(isOutOfDialogLimit),
                'is-highlighted': !!_unref(userdata)?.highlightColor,
                'is-hidden-for-operator': __props.buddyList.isCustomSearchList && _unref(userdata) && _unref(userdata).isHiddenForOperator
            }),
          style: _normalizeStyle({
                '--client-highlight-color': _unref(userdata)?.highlightColor
            }),
          selected: __props.selected,
          onClick: emitClick
        }, {
          default: _withCtx(() => [
            (_unref(userdata))
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(CoreUiChatClientAvatar, {
                    class: "mr-2",
                    client: _unref(userdata),
                    "show-status": _unref(isShowStatus),
                    "integration-platform": _unref(integrationPlatform),
                    "show-letters": !_unref(CoreUiChatHistoryHelper).isOneOfCrossOperatorsChat(_unref(userdata))
                  }, null, 8, ["client", "show-status", "integration-platform", "show-letters"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(ClientIconsBeforeName, {
                        class: "text-nowrap",
                        userdata: _unref(userdata),
                        "max-options-icons-count": MAX_OPTION_ICONS
                      }, null, 8, ["userdata"]),
                      _createElementVNode("div", {
                        class: _normalizeClass({
                                    'text-truncate descr': true,
                                    'flex-fill': !_unref(lastMessage)
                                })
                      }, _toDisplayString(_unref(userdata).displayDescr), 3),
                      (_unref(lastMessage))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (_unref(lastMessage).isSendByClient && _unref(configInstance).buddyListShowTimeFromLastQuestion)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  type: "warning",
                                  size: "small",
                                  effect: __props.selected ? 'plain' : null
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(secondsFormat(_unref(lastMessageTime) as number)), 1)
                                  ]),
                                  _: 1
                                }, 8, ["effect"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_unref(StringHelper).capitalize(_unref(lastMessageTime) as string)), 1)
                                ], 64))
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(isCloseAvailable))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                              circle: "",
                              type: "danger",
                              plain: "",
                              size: "small",
                              class: "close-button"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("i", {
                                  class: _normalizeClass(`${_unref(icon)('times')} fal m-0`)
                                }, null, 2)
                              ]),
                              _: 1
                            })), [
                              [
                                _directive_on_native,
                                close,
                                "click",
                                { stop: true }
                              ]
                            ])
                          ]))
                        : (__props.buddyList.isCustomSearchList)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                circle: "",
                                type: _unref(userdata).isHiddenForOperator ? 'success' : 'danger',
                                plain: "",
                                size: "small",
                                class: "close-button"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(`${_unref(icon)(_unref(userdata).isHiddenForOperator ? 'eye' : 'eye-slash')} fal m-0`)
                                  }, null, 2)
                                ]),
                                _: 1
                              }, 8, ["type"])), [
                                [
                                  _directive_on_native,
                                  toggleHide,
                                  "click",
                                  { stop: true }
                                ]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                      (_unref(userdata).crossOperatorConversationUnreadMessageCount > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_el_tag, {
                              size: "small",
                              type: "primary",
                              class: "ml-1 unreaded-badge"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(FontAwesomeIcon, {
                                  icon: "user-headset",
                                  class: "m-0 mr-1"
                                }),
                                _createTextVNode(" " + _toDisplayString(_unref(userdata).crossOperatorConversationUnreadMessageCount), 1)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(userdata).unreadedMessageIds.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (_unref(isNewUnreadedDialog))
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  size: "small",
                                  type: _unref(unreadedCountBadgeType),
                                  class: "ml-1 unreaded-badge"
                                }, {
                                  default: _withCtx(() => [
                                    (_unref(isNewUnreadedDialog))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_unref(__)("Новый")), 1)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["type"]))
                              : _createCommentVNode("", true),
                            (_unref(userdata).unreadedMentionMessageIds.length)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 1,
                                  size: "small",
                                  type: _unref(unreadedCountBadgeType),
                                  class: "ml-1 unreaded-badge pl-0 pr-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(FontAwesomeIcon, {
                                      icon: "at",
                                      class: "m-0"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["type"]))
                              : (!_unref(isNewUnreadedDialog) || _unref(userdata).unreadedMessageIds.length > 1)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 2,
                                    size: "small",
                                    type: _unref(unreadedCountBadgeType),
                                    class: "ml-1 unreaded-badge"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(userdata).unreadedMessageIds.length), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["type"]))
                                : _createCommentVNode("", true)
                          ]))
                        : (_unref(unreadedStateList).length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createVNode(_component_el_tag, {
                                size: "small",
                                type: "danger",
                                class: "ml-1 unreaded-badge reaction"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(FontAwesomeIcon, {
                                    icon: _unref(unreadedStateList)[0].icon,
                                    bold: "",
                                    class: "m-0"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                      (_unref(dialogStatus)?.isShowIcon && _unref(userdata).lastDialog?.assigned.isAssignedToYou)
                        ? _withDirectives((_openBlock(), _createBlock(_component_el_tag, {
                            key: 6,
                            size: "small",
                            type: "danger",
                            class: _normalizeClass({
                                    'ml-1 unreaded-badge font-weight-bold dialog-status': true,
                                    'hide-on-hover': _unref(dialogStatus).isRemoveFromBuddyListAvailable && _unref(userdata).unreadedMessageIds.length == 0
                                }),
                            style: _normalizeStyle({background: _unref(dialogStatus).color})
                          }, {
                            default: _withCtx(() => [
                              _createVNode(FontAwesomeIcon, {
                                icon: _unref(dialogStatus).icon,
                                "icon-style": _unref(dialogStatus).iconStyle
                              }, null, 8, ["icon", "icon-style"])
                            ]),
                            _: 1
                          }, 8, ["class", "style"])), [
                            [_directive_my_tooltip, _unref(dialogStatus).descr]
                          ])
                        : _createCommentVNode("", true),
                      (_unref(userdata).isPinned)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 7,
                            class: _normalizeClass(`${_unref(icon)('thumbtack', 'fas')} rotate-45 icon first-line-icon text-muted ml-2`)
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ]),
                    (_unref(OperatorApplicationConfigInstance).showYouInDialogForOfflineNotification && _unref(dialogStatus)?.isHaveNoAnswer && _unref(userdata).lastDialog && _unref(userdata).lastDialog.isOperatorInDialog && _unref(userdata).unreadedMessageIds.length == 0 && _unref(userdata).lastDialog.assigned.isAssignedToYou)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "danger",
                            class: "d-block text-center text-truncate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(__)("Вы участвовали в этом диалоге")), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(optionsWithIcons).length >= MAX_OPTION_ICONS)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(BuddyListItemIcons, { "options-with-icons": _unref(optionsWithIcons) }, null, 8, ["options-with-icons"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      ((_unref(userdata).lastMessage || _unref(typing)) && _unref(configInstance).buddyListShowLastMessage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_unref(typing))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(typing).label) + ": ", 1),
                                  _createVNode(CoreUiHtmlify, {
                                    emoji: "",
                                    value: _unref(typing).text
                                  }, null, 8, ["value"])
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass({
                                            'last-message-sender': true,
                                            client: !_unref(lastMessageSender)
                                        })
                                  }, [
                                    (_unref(lastMessageSender))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_unref(lastMessageSender)) + ": ", 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(_unref(__)('Клиент')) + ": ", 1)
                                        ], 64))
                                  ], 2),
                                  (typeof _unref(userdata).lastMessage.text == 'string')
                                    ? (_openBlock(), _createBlock(CoreUiHtmlify, {
                                        key: 0,
                                        emoji: "",
                                        value: _unref(StringHelper).htmlToText(_unref(StringHelper).bbcodeToHtml(_unref(userdata).lastMessage.text))
                                      }, null, 8, ["value"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                          ]))
                        : _createCommentVNode("", true),
                      (!__props.buddyList.isCrossOperatorsChat)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_unref(userdata).lastMessage && _unref(configInstance).buddyListDialogState)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  (_unref(getCurrentDialogOfClient)(_unref(userdata)))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(`${_unref(icon)('comment', 'text-success fas')}`)
                                        }, null, 2),
                                        _createTextVNode(" " + _toDisplayString(_unref(__)("В процессе диалога")), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(`${_unref(icon)('flag-checkered')} orange-color`)
                                        }, null, 2),
                                        _createTextVNode(" " + _toDisplayString(_unref(__)("Диалог завершён")), 1)
                                      ], 64))
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(userdata).lastPage && _unref(configInstance).buddyListShowLastPage && !_unref(isFree))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(icon)('globe'))
                                  }, null, 2),
                                  _createElementVNode("a", {
                                    href: __props.selected ? _unref(userdata).lastPage.url : null,
                                    target: "_blank"
                                  }, _toDisplayString(_unref(userdata).lastPage.title ? _unref(userdata).lastPage.title : _unref(userdata).lastPage.url), 9, _hoisted_17)
                                ]))
                              : _createCommentVNode("", true),
                            (!_unref(userdata).integration && _unref(configInstance).buddyListShowReferer && !_unref(isFree) && _unref(canViewReferer))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(icon)('hand-point-right'))
                                  }, null, 2),
                                  (_unref(referer))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: __props.selected ? _unref(referer) : null,
                                        target: "_blank"
                                      }, _toDisplayString(_unref(referer)), 9, _hoisted_19))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_unref(__)("Прямой переход")), 1)
                                      ], 64))
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(userdata).questionCategory && _unref(configInstance).buddyListShowQuestionCategory)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(icon)('question-circle'))
                                  }, null, 2),
                                  _createTextVNode(" " + _toDisplayString(_unref(userdata).questionCategory), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (!_unref(userdata).integration && _unref(configInstance).buddyListShowStatistic)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(_unref(icon)('sign-in'))
                                        }, null, 2),
                                        (!_unref(isFree))
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(_unref(userdata).visitStatistic.visitCount), 1)
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(" - ")
                                            ], 64))
                                      ])), [
                                        [_directive_my_tooltip, !_unref(isFree) ? {delay: 500, text: `${_unref(__)('Количество заходов на сайт')}: ${_unref(userdata).visitStatistic.visitCount}`} : null]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(_unref(icon)('eye'))
                                        }, null, 2),
                                        (!_unref(isFree))
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(_unref(userdata).visitStatistic.lastVisitPageCount), 1)
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(" - ")
                                            ], 64))
                                      ])), [
                                        [_directive_my_tooltip, !_unref(isFree) ? _unref(pageCountTooltip) : null]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(_unref(icon)('clock'))
                                        }, null, 2),
                                        (!_unref(isFree))
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(secondsFormat(_unref(currentVisitTime))), 1)
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(" - ")
                                            ], 64))
                                      ])), [
                                        [_directive_my_tooltip, !_unref(isFree) ? _unref(visitsTooltip) : null]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_26, [
                                    (_unref(city))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("i", {
                                            class: _normalizeClass(`${_unref(icon)('map-marker')}`)
                                          }, null, 2),
                                          (!_unref(isFree))
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(_toDisplayString(_unref(city)), 1)
                                              ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode(_toDisplayString(_unref(__)("Бесплатная версия")), 1)
                                              ], 64))
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(configInstance).buddyListShowClientTags && _unref(userdata).tags.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _createVNode(Tags, {
                                    class: "own-color",
                                    tags: _unref(userdata).tags,
                                    maximum: 6,
                                    "with-border": "",
                                    "possible-tags": _unref(site) ? _unref(site).clientTags : [],
                                    style: {"white-space":"initial"}
                                  }, null, 8, ["tags", "possible-tags"])
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(configInstance).buddyListShowDialogTags && _unref(getCurrentDialogOfClient)(_unref(userdata)) && _unref(getCurrentDialogOfClient)(_unref(userdata)).tags)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  _createVNode(Tags, {
                                    class: "own-color",
                                    tags: _unref(getCurrentDialogOfClient)(_unref(userdata)).tags,
                                    maximum: 6,
                                    "with-border": "",
                                    "possible-tags": _unref(site) ? _unref(site).dialogTags : [],
                                    style: {"white-space":"initial"}
                                  }, null, 8, ["tags", "possible-tags"])
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(configInstance).buddyListShowAttachedOperators && _unref(attachedOperators).length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attachedOperators), (operator) => {
                                    return _withDirectives((_openBlock(), _createBlock(_component_el_tag, {
                                      type: "info",
                                      class: "h-auto mt-1 overflow-visible",
                                      style: {"padding-top":"1px","padding-left":"1px","padding-bottom":"1px","border-color":"currentColor !important"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_30, [
                                          _createVNode(CoreUiOperatorAvatar, {
                                            operator: operator,
                                            size: "20px"
                                          }, null, 8, ["operator"]),
                                          _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(getOperatorDisplayName)(operator)), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)), [
                                      [_directive_my_tooltip, _unref(__)('Закрепленные операторы')]
                                    ])
                                  }), 256))
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_unref(crossOperatorChat)?.login)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_unref(configInstance).crossOperatorBuddyListShowLogin)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        _createVNode(FontAwesomeIcon, { icon: "user" }),
                                        _createTextVNode(" " + _toDisplayString(_unref(crossOperatorChat).login), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_unref(configInstance).crossOperatorBuddyListShowGroup && getOperatorGroups(_unref(crossOperatorChat).login))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _createVNode(FontAwesomeIcon, { icon: "users" }),
                                        _createTextVNode(" " + _toDisplayString(getOperatorGroups(_unref(crossOperatorChat).login)), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(Skeleton),
                  _createVNode(Skeleton, { class: "mt-2 w-75 opacity-5" })
                ], 64))
          ]),
          _: 1
        }, 8, ["class", "style", "selected"])), [
          [_directive_my_tooltip, _unref(textTooltip)]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})